// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import ScheduleOutlined from '/Users/caocuong.tran/Desktop/SEA/GRN/GRN.AOV-planing-react/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/ScheduleOutlined';
import UnorderedListOutlined from '/Users/caocuong.tran/Desktop/SEA/GRN/GRN.AOV-planing-react/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/UnorderedListOutlined';
export default { ScheduleOutlined, UnorderedListOutlined };
